import axios from 'axios';
import Conf from '@/config/config';
import { Message } from "element-ui";
import {getUser} from '@/store/userStore'
import router from '@/router';


axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',
    baseURL: Conf.API_HOST,
    timeout: 60000
});
axios.defaults.baseURL = Conf.API_HOST
axios.defaults.timeout = 60000
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Content-Type'] = 'application/json'


axios.interceptors.request.use(
    (config: any) => {
        // 添加token
        const  userInfo = getUser()
        if(userInfo){
            config.headers.common['Authorization'] = userInfo.token || ''
        }
        return config;
    },
    (error: any) => {
        console.log(error);
        return Promise.reject();
    }
);

export async function CommonFetchPost(url: string , param = {}) {
    const result = await axios.post(url, param)
    const {data,status} = result
    if(status !== 200){
        Message.error("服务器繁忙，请稍后再试");
        return
    }
    if(data.code == 1300004){
        // 未登录 
        Message.error(data.msg);
        router.push('/login')
        return
    } else if(data.code != 10000){
        // 异常
        Message.error(data.msg);
        return
    }
    return data.data
  }

/** 长耗时 POST：失败抛错，便于调用方区分成功/失败 */
export async function CommonFetchPostLong(url: string, param = {}, timeout = 120000) {
    try {
        const result = await axios.post(url, param, { timeout })
        const { data, status } = result
        if (status !== 200) {
            Message.error('服务器繁忙，请稍后再试')
            throw new Error('服务器繁忙，请稍后再试')
        }
        if (data.code == 1300004) {
            Message.error(data.msg)
            router.push('/login')
            throw new Error(data.msg || '未登录')
        }
        if (data.code != 10000) {
            Message.error(data.msg)
            throw new Error(data.msg || '请求失败')
        }
        return data.data
    } catch (e: any) {
        if (e && e.response && e.response.status === 404) {
            const tip = '接口不存在(404)，请确认 cy-api 已重新编译并重启后再试'
            Message.error(tip)
            throw new Error(tip)
        }
        if (e && e.message && e.message.indexOf('timeout') >= 0) {
            const tip = '请求超时，请缩小日期范围后重试'
            Message.error(tip)
            throw new Error(tip)
        }
        throw e
    }
}

// 导出
export async function CommonExportGet(url: string , param: any = {}, fileName = 'default.xlsx') {
    let paramStr = ''
    if (param != null) {
      paramStr = '?'
      Object.keys(param).forEach((key) => {
        if(param[key] != undefined && param[key] != null){
            paramStr += key + '=' + param[key] + '&'
        }
      })
      paramStr.substring(paramStr.length - 1)
    }
    const jumpUrl = url + paramStr
    const res = await axios.get(jumpUrl,{responseType:'blob'})
    const blob = new Blob([res.data])
    const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
    const a = document.createElement('a') //创建a标签
    a.style.display = 'none'
    a.href = href // 指定下载链接
    a.download = fileName //指定下载文件名
    a.click() //触发下载
    URL.revokeObjectURL(a.href) //释放URL对象
}